import en from './en'
import es from './es'
import ar from './ar'
import mm from './mm'
import my from './my'
import zh from './zh'
import kh from './kh'
import pt_BR from './pt'
import id from './id'
import ph from './ph'


export default {
  en,
  es,
  ar,
  kh,
  mm,
  my,
  zh,
  pt_BR,
  id,
  ph
}
